const STORAGE_PREFIX = "adrise_exp_";

export function getExperimentVariant(experimentKey, variants = ["A", "B"]) {
    if (typeof window === "undefined") return variants[0];

    const url = new URL(window.location.href);
    const force = (url.searchParams.get(`exp_${experimentKey}`) || "").toUpperCase();
    if (variants.includes(force)) {
        localStorage.setItem(`${STORAGE_PREFIX}${experimentKey}`, force);
        return force;
    }

    const storageKey = `${STORAGE_PREFIX}${experimentKey}`;
    const existing = (localStorage.getItem(storageKey) || "").toUpperCase();
    if (variants.includes(existing)) return existing;

    const pick = Math.random() < 0.5 ? variants[0] : variants[1];
    localStorage.setItem(storageKey, pick);
    return pick;
}
